import React from "react";

import { Fade } from "react-awesome-reveal";

import heroPortfolio from "assets/images/hero/logistic.png";

export default function HeroPortfolio2() {
  return (
    <section className="hero sm:items-center lg:items-start sm:flex-row ">
      <div className="w-full sm:w-1/2 flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 sm:mt-6 lg:mt-6 xl:mt-20">
        <Fade direction="up" triggerOnce>
          <h1 className="text-6xl text-blue-600 font-bold leading-tight mb-5">
            Our Services
          </h1>
        </Fade>
        <Fade direction="up" triggerOnce delay={400}>
          <p className="font-light text-xl  text-gray-400 leading-relaxed">
            "We specialize in providing reliable and efficient marine logistics
            solutions, ensuring the seamless transportation of goods across
            global waters. Committed to safety, sustainability, and timely
            delivery, we offer customized shipping, freight forwarding, and
            supply chain management services. With a focus on operational
            excellence, we streamline maritime logistics to support businesses
            worldwide."
          </p>
        </Fade>
      </div>
      <div className="w-full sm:w-1/2 sm:pr-12">
        <Fade direction="up" triggerOnce>
          <img
            src={heroPortfolio}
            alt="Hero"
            className="rounded-lg shadow-xl"
          />
        </Fade>
      </div>
    </section>
  );
}
